var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "topbar" },
        [
          _c("SupporterSearch", {
            staticClass: "search",
            on: {
              click: _vm.navigateToSupporterDetail,
              searching: _vm.searching
            }
          }),
          _c("div", { staticClass: "flex-grow" }),
          _c("div", [
            _c(
              "button",
              {
                staticStyle: { "white-space": "nowrap" },
                on: {
                  click: function($event) {
                    return _vm.showDonationModal()
                  }
                }
              },
              [_vm._v("New Supporter")]
            )
          ])
        ],
        1
      ),
      _vm.isDonationModalDisplayed ? _c("DonationModal") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }